export default {
  'AvgSentiment.title': 'Средняя тональность (CSAT)',
  'AvgSentiment.good': 'хорошо',
  'AvgSentiment.normal': 'нормально',
  'AvgSentiment.bad': 'плохо',
  'AvgSentiment.tooltipText':
    'Тональность — это мнения или чувства людей по поводу ваших продуктов. Средняя тональность рассчитывается на основе тональности всех продуктов в вашем аккаунте',
}
